import { Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { CancelIcon, CheckIcon, CheckMarkIcon, CrownIcon, SaveIcon } from "../../../common/icons";
import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { ORG_VALUE_LISTS } from "../../../../graphql/valuelist-gql";
import { IValueListLight } from "../../../../types/valuelist";
import {  useEffect, useState } from "react";
import {  GET_ORG_POSITIONS, GET_POSITION_DETAIL, HAS_MANAGEMENT, UPDATE_POSITION } from "../../../../graphql/position-gql";
import { notifySuccess } from "../../../../services/notification";
import { messages } from "../../../../i18n/message";
import { LOCALES } from "../../../../i18n/locales";
import { IPosition, IPositionInput, IPositionTitle } from "../../../../types/position";
import PositionTypeahead from "../../../common/typeahead/position-typeahead";
import Select from "../../../common/select/select";
import { formatExcludeComma } from "../../../../types/constants";
import { deepEqual } from "../../../../utils/commons";
import "./position-information.scss";
import Info from "../../../common/info";
import { fullTitle } from "../../../../utils/full-title";
import useAuth from "../../../../hook/useAuth";
import { useFrench } from "../../../french/french-context";
import SpinnerOverlay from "../../../common/spinner/spinner";
import Button from "../../../common/button";
type PositionInformationProp = {
    position:IPosition
    updateSelectedPosition?:(updatedPosition:IPosition)=>void
}

const PositionInformation =(prop:PositionInformationProp)=>{
    const {position,updateSelectedPosition} = prop;
    const [prefixLengthError,setPrefixLengthError] = useState<string>('');
    const [prefixCharError,setPrefixCharError] = useState<string>('');
    const [suffixLengthError,setSuffixLengthError] = useState<string>('');
    const [suffixCharError,setSuffixCharError] = useState<string>('');
    const [titleError,setTitleError] = useState<string>('');
    const [managementIndicatorError, setManagementIndicatorError] =  useState<string>('');
    const [valid,setValid] = useState<boolean>(true);
    const [manageable, setManageable] = useState<boolean>(true);
    const [positionFullTitle,setPositionFullTitle] =  useState<string>('');
    const [selectedPositionTitle,setSelectedPositionTitle] = useState<IPositionTitle>({positionTitleId:position.positionTitle.positionTitleId,positionName:position.positionTitle.positionName});
    const [anyChange,setAnychange] = useState<boolean>(false);
    const [ updatePosition ,{loading:updateLoading}] = useMutation(UPDATE_POSITION);
    const [hasManagement]= useLazyQuery(HAS_MANAGEMENT,{fetchPolicy:'no-cache'});
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const { isFrenchTranslator } = useAuth();
    const [cloned,setCloned] = useState<boolean>(false);
    
    const [editedPosition, setEditedPosition] = useState<IPositionInput>(
        {positionTitleId:0, positionHonorificId:0, positionPrefix:'',positionSuffix:'', positionName:'',
         bilingualIndicator:false, managementIndicator:false, positionNameFMSync: false,
         positionNameFFSync: false, positionNameFM: '',positionNameFF: ''
        }
    )
    const initPositionInput = () => {
        const init : IPositionInput = {
            positionTitleId: position.positionTitle.positionTitleId, 
            positionName: position?.positionName,
            positionHonorificId:position.positionHonorificId, 
            positionPrefix:position.positionPrefix?position.positionPrefix:'', 
            positionSuffix:position.positionSuffix?position.positionSuffix:'',
            bilingualIndicator:position.bilingualIndicator,
            managementIndicator:position.managementIndicator,
            positionNameFMSync: position.positionNameFMSync,
            positionNameFFSync:position.positionNameFFSync,
            positionNameFM: position.positionNameFM,
            positionNameFF: position.positionNameFF
        }
        return init;
    }

    const [frenchState] = useFrench();

    //useEffect(() => {if (position) {getPositionDetail({variables:{positionId : position?.positionId}});}}, [position])

    useEffect(() => {
        setCloned(!!position?.shareLinkId)
        if (position) {
            setEditedPosition(initPositionInput())
            setPositionFullTitle(position.fullPositionName)
        }
    }, [position])

    useEffect(() => {

        if (position) {
            hasManagement({variables:{positionId:position.positionId}}).then(res=>{
                setManageable(!res.data.hasManagement)
            })
        }
    }, [position])

    useEffect(() => {

        //console.log("editedPosition:",editedPosition)

        if(editedPosition?.positionPrefix && editedPosition?.positionPrefix?.length>100)
            setPrefixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
            setPrefixLengthError('')

        if(editedPosition?.positionPrefix && formatExcludeComma.test(editedPosition?.positionPrefix))
            setPrefixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setPrefixCharError('')

        if(editedPosition?.positionSuffix && editedPosition?.positionSuffix?.length>100)
            setSuffixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
        setSuffixLengthError('')

        if(editedPosition?.positionSuffix && formatExcludeComma.test(editedPosition?.positionSuffix))
            setSuffixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setSuffixCharError('')

        if(!manageable && editedPosition.managementIndicator)
            setManagementIndicatorError(messages[LOCALES.ENGLISH].ERROR['5614'])
        else
            setManagementIndicatorError('')
        setAnychange(!deepEqual(initPositionInput(),editedPosition));

    }, [editedPosition])

    useEffect(() => {
        if(!isFrenchTranslator){
            setValid(editedPosition?.positionTitleId!==0
                && !titleError
                && !prefixCharError && !prefixLengthError
                && !suffixCharError && !suffixLengthError
                && !managementIndicatorError
            )
        }
    },[titleError,prefixCharError,prefixLengthError,suffixCharError,suffixLengthError,managementIndicatorError,editedPosition]);

    const updatePositionFullName = (prefix:string|undefined,positionName:string|undefined,suffix:string|undefined) =>{
        const myfullTitle = fullTitle(undefined,prefix,positionName,suffix)
        setPositionFullTitle(myfullTitle);
    }
    const titleSelected = (positionTitle: IPositionTitle | null) => {
        setSelectedPositionTitle(positionTitle||{positionTitleId:0,positionName:''});
        setEditedPosition({ ...editedPosition, positionTitleId: positionTitle?.positionTitleId||0 , positionNameFMSync: false, positionNameFFSync: false})
        updatePositionFullName(editedPosition?.positionPrefix,positionTitle?.positionName,editedPosition?.positionSuffix)
    }
    const onPositionPrefixChange = (event: any) => {
        setEditedPosition({ ...editedPosition, positionPrefix: event.target.value, positionNameFMSync: false, positionNameFFSync: false})
        updatePositionFullName(event.target.value,selectedPositionTitle?.positionName,editedPosition?.positionSuffix,)
    
    }
    const onPositionSuffixChange = (event: any) => {
        setEditedPosition({ ...editedPosition, positionSuffix: event.target.value, positionNameFMSync: false, positionNameFFSync: false })  
        updatePositionFullName(editedPosition?.positionPrefix,selectedPositionTitle?.positionName, event.target.value)
    
    }
    const onHonorificChange = (event: any) => {
        setEditedPosition({ ...editedPosition, positionHonorificId: event.target.value})
    }
    const honorific = () =>{
        if(editedPosition.positionHonorificId && orgValueLists?.posHonorifics){
            const orgValueList = orgValueLists.posHonorifics.find((item:IValueListLight)=>item.id===editedPosition.positionHonorificId)
            return orgValueList?orgValueList.label:'';
        }
    }
    const onManagementIndicatorChange = (event: any) => {setEditedPosition({ ...editedPosition, managementIndicator: !editedPosition.managementIndicator })}
    const onbilingualIndicatorChange = (event: any) => {setEditedPosition({ ...editedPosition, bilingualIndicator: !editedPosition.bilingualIndicator })}
    const onPositionNameFMSyncChange = (event: any)=>{setEditedPosition({ ...editedPosition, positionNameFMSync: event.target.checked })}
    const onPositionNameFFSyncChange = (event: any)=>{setEditedPosition({ ...editedPosition, positionNameFFSync: event.target.checked })}
    const getRefetchQuery = () => {return [{query: GET_POSITION_DETAIL, variables: { positionId: position.positionId}}]}
    const onSaveHandle = () => {
        const inputPosition = {...editedPosition}
        delete inputPosition.positionName;
        //console.log("inputPosition:",inputPosition)
        updatePosition({
            variables: {
                positionId: position?.positionId,
                input: {
                    ...inputPosition
                }
            },
            update(cache,{data:{updatePosition}}){
                //update for position list
                if(position?.orgId){
                    const cachedOrg = cache.readQuery<{
                        org:{
                            positions:Array<IPosition>
                        }
                    }>({
                        query: GET_ORG_POSITIONS,
                        variables: { orgId: position.orgId},
                    });

                    if(cachedOrg){

                        const updatedPositions = [...cachedOrg.org.positions];
                        const updatedPositionIndex = updatedPositions.findIndex(
                            (pos: IPosition) => pos.positionId === updatePosition.positionId
                        );
                        // Modify the cache data to reflect the mutation result
                        if (updatedPositionIndex !== -1) {
                            updatedPositions[updatedPositionIndex] = updatePosition;
                        }
                        // Set Responsible for Organization on top of the positions list 
                        const responsibleIndex = updatedPositions.findIndex(item => item.managementIndicator);
                        if (responsibleIndex !== -1) {
                            const [responsibleItem] = updatedPositions.splice(responsibleIndex, 1);
                            updatedPositions.unshift(responsibleItem);
                        }
                        // Update the cached data with the modified positions array
                        cache.writeQuery({
                            query: GET_ORG_POSITIONS,
                            variables: { orgId: position.orgId||undefined },
                            data: {
                                org: {
                                    ...cachedOrg.org,
                                    positions: updatedPositions,
                                },
                            },
                        });

                        updateSelectedPosition&&updateSelectedPosition({...position,...updatePosition});

                    }
                }
            },
            refetchQueries: getRefetchQuery(),
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                data && notifySuccess()
            }
        })
    }

    return (<div role="region" aria-label="Position Detail" className="positionDetail">
            {updateLoading && <SpinnerOverlay />}
             <Form>
                <Info><b>Full Title Preview:</b>&nbsp;{positionFullTitle}</Info>
                {
                    frenchState.isFrenchChecked && <>
                        <Info><b>Full Title Preview (French - Masculine):</b>&nbsp;<span lang="fr">{editedPosition.positionNameFM}</span></Info>
                        <FormGroup row>
                            <div className='col-md-3'>
                                <Input id="nameTranslated" type="checkbox" checked={editedPosition?.positionNameFMSync || false} onChange={onPositionNameFMSyncChange} disabled={cloned || !editedPosition.positionNameFM}/> {' '}
                                <Label for="nameTranslated" role="region" aria-label='Translated Full Title Masculine'>Translated Full Title Masculine</Label>
                            </div>
                        </FormGroup>
                        <Info><b>Full Title Preview (French - Feminine):</b>&nbsp;<span lang="fr">{editedPosition.positionNameFF}</span></Info>
                        <FormGroup row>
                            <div className='col-md-3'>
                                <Input id="nameTranslated1" type="checkbox" checked={editedPosition?.positionNameFFSync || false} onChange={onPositionNameFFSyncChange} disabled={cloned || !editedPosition.positionNameFF}/> {' '}
                                <Label for="nameTranslated1" role="region" aria-label='Translated Full Title Feminine'>Translated Full Title Feminine</Label>
                            </div>
                        </FormGroup>
                    </>
                }
                <br/>
                
                    <Row>
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="pos-info-title" sm={4}>
                                    Title(required):
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator && <PositionTypeahead elementId="pos-info-title" 
                                        positionTitleSelected={titleSelected} init={position.positionTitle} 
                                        validate={setTitleError} isRole={position.isRole} 
                                        disabled={cloned}
                                    />}
                                    {isFrenchTranslator && <div>{selectedPositionTitle.positionName}</div>}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="pos-info-prefix" sm={4}>
                                    Prefix:
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator &&<div>
                                            <Input id="pos-info-prefix" aria-labelledby="pos-info-prefix" 
                                                placeholder="Enter a prefix for the position title"
                                                value={editedPosition?.positionPrefix||''}
                                                onChange={onPositionPrefixChange} 
                                                invalid={!!prefixLengthError || !! prefixCharError}
                                                disabled={cloned}
                                            />
                                            <FormFeedback>{prefixLengthError}</FormFeedback>
                                            <FormFeedback>{prefixCharError}</FormFeedback>
                                        </div>}
                                    {isFrenchTranslator &&
                                    <div >
                                        {editedPosition.positionPrefix}
                                    </div>}
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="pos-info-suffix" sm={4}>
                                    Suffix:
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator && <div>  
                                        <Input id="pos-info-suffix"  placeholder={`Enter a suffix for the ${position?.isRole?"role":"position"} title`}
                                            value={editedPosition?.positionSuffix||'' }
                                            onChange={onPositionSuffixChange} 
                                            invalid={!!suffixLengthError || !! suffixCharError}
                                            disabled={cloned}
                                        />
                                        <FormFeedback>{suffixLengthError}</FormFeedback>
                                        <FormFeedback>{suffixCharError}</FormFeedback>
                                    </div>}
                                    {isFrenchTranslator && <div>
                                        {editedPosition.positionSuffix}
                                      </div>
                                    }
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="pos-info-honorific" sm={4}>
                                    Honorific:
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator &&   
                                        <div >   
                                            <Select id="pos-info-honorific"  value={editedPosition?.positionHonorificId || 0 } onChange={onHonorificChange} disabled={cloned}>
                                                <option value='0' disabled>Select an honorific</option>
                                                <option value='-1'></option>
                                                {orgValueLists.posHonorifics.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                                            </Select>
                                        </div>
                                    }
                                    {isFrenchTranslator &&
                                        <div >
                                            {honorific()}
                                        </div>
                                    }
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3} >
                            <Button color="primary" style={{marginRight:'20px'}} onClick={onSaveHandle} disabled={!valid || !anyChange}><SaveIcon />&nbsp;Save Changes</Button>
                        </Col>
                        <Col sm={4}>
                            {!isFrenchTranslator && <Input id="pos-info-managementIndicator"
                                type="checkbox" style={{verticalAlign:'middle'}}
                                checked={editedPosition?.managementIndicator||false}
                                onChange={onManagementIndicatorChange}
                                invalid={!!managementIndicatorError}
                                disabled={cloned}
                            />
                            }
                            <Label for="pos-info-managementIndicator" check style={{verticalAlign:'middle',marginRight:'20px'}}>
                            {
                                isFrenchTranslator && editedPosition?.managementIndicator && <CheckMarkIcon/>
                            }
                            {
                                isFrenchTranslator && !editedPosition?.managementIndicator && <CancelIcon/>
                            }  &nbsp;<CrownIcon alt="Responsible for Organization"/>&nbsp;Responsible for Organization
                            </Label>
                            <FormFeedback role="alert">{managementIndicatorError}</FormFeedback>
                        </Col>
                        <Col sm={3} >
                            {!isFrenchTranslator && <Input id="pos-info-bilingualIndicator" 
                                type="checkbox" style={{ verticalAlign: 'middle' }} 
                                checked={editedPosition?.bilingualIndicator || false} 
                                onChange={onbilingualIndicatorChange} 
                                disabled={cloned}
                            />}
                            {
                                isFrenchTranslator && editedPosition?.bilingualIndicator && <CheckMarkIcon />
                            }
                            {
                                isFrenchTranslator && !editedPosition?.bilingualIndicator && <CancelIcon />
                            }
                            <Label for="pos-info-bilingualIndicator" check style={{verticalAlign:'middle',marginRight:'20px'}}>
                                &nbsp;Position is Bilingual
                            </Label>
                        </Col>
                        <Col sm={3} />
                    </Row>                 
                </Form>
            </div>)
}

export default PositionInformation;
